var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowUp = function ArrowUp(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 360 227.3' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'currentColor', d: 'M358 180.2l-44.3 43L183.4 89.1 45.3 223.2l-43-44.3L180.7 7.4l4.9-4.8z' })
    )
  );
};
/*eslint-enable */

export default ArrowUp;
//# sourceMappingURL=ArrowUp.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowUp.js